import React from "react";
import { Box, Typography } from "@mui/material";

const RainbowAnchorContext = (props) => {
  const { doctor, date, time, user } = props;
  const username = user?.username || "Guest";

  const providerName = doctor || "health professional";

  return (
    <Box
      sx={{
        background:
          "linear-gradient(to right, #94f8ff3d 0%, #7ca5ff56 52%, #ffa7d27e 100%)",
        p: 1,
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        mb: 1,
      }}
    >
      <Typography
        variant="body2"
        color="#1b1b1bff"
        fontWeight={500}
        fontFamily={"sans-serif"}
      >
        Hi <strong>{username}</strong>! Your appointment with{" "}
        <strong>{providerName}</strong> is on{" "}
        <strong>{date ? date : "date?"}</strong> at{" "}
        <strong>{time ? time : "what time?"}</strong>.
      </Typography>
    </Box>
  );
};

  export default RainbowAnchorContext;